import modelBaseV2 from '../models/model-base-v2.model';

const exportUserExcelTemplate = (exportConfig, fileName) => {
  return modelBaseV2.postDownload('/api/user/file/export/tr/file', { body: exportConfig }, fileName);
}
const exportExecutespExcelTemplate = (exportConfig, fileName) => {
  return modelBaseV2.postDownload('/api/executesp/export/tr/file', { body: exportConfig }, fileName);
}

const exportRetailExcelTemplate = (exportConfig, fileName) => {
  return modelBaseV2.postDownload('/api/retail/file/export/tr/file', { body: exportConfig }, fileName);
}

const downloadUserCommonExcel = (params, fileName) => {
  const path = '/api/user/file/export/commonexcel';
  return modelBaseV2.postDownload(path, { body: params }, fileName);
}

const downloadResultFileByFileID = (fileId, fileName) => {
  return modelBaseV2.getDownload('/api/user/file/temp/:fileId', { params: { fileId } }, fileName)
}

const downloadUserFileByFileID = (fileId, fileName) => {
  return modelBaseV2.getDownload('/api/file/:fileId', { params: { fileId } }, fileName)
}

export {
  exportUserExcelTemplate,
  exportExecutespExcelTemplate,
  exportRetailExcelTemplate,
  downloadUserCommonExcel,
  downloadResultFileByFileID,
  downloadUserFileByFileID
};

